import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";

import { DIALOG_DATA, DialogRef, DialogService } from "@bitwarden/components";

import { SharedModule } from "../shared";

export type CustomizeGlobalDomainDialogData = {
  domains: string;
};

export type CustomizeGlobalDomainDialogResult =
  | { action: "save"; domains: string }
  | { action: "delete" };

@Component({
  templateUrl: "customize-global-domain-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule],
})
export class CustomizeGlobalDomainDialogComponent {
  readonly formGroup = new FormGroup({
    domain: new FormControl("", { nonNullable: true }),
  });

  constructor(
    @Inject(DIALOG_DATA) data: CustomizeGlobalDomainDialogData,
    private readonly dialogRef: DialogRef<CustomizeGlobalDomainDialogResult>,
  ) {
    this.formGroup.controls.domain.setValue(data.domains);
  }

  deleteDomain(): void {
    void this.dialogRef.close({ action: "delete" });
  }

  readonly submit = async () => {
    void this.dialogRef.close({
      action: "save",
      domains: this.formGroup.controls.domain.value.trim(),
    });
  };

  static open(dialogService: DialogService, data: CustomizeGlobalDomainDialogData) {
    return dialogService.open<CustomizeGlobalDomainDialogResult>(
      CustomizeGlobalDomainDialogComponent,
      { data },
    );
  }
}
